import React from 'react';
import { History } from 'history';
import { InputSelect, InputPicklist } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './journalgroupdetail-model';  //editable..
import TransactiontypePicklist from '../transactiontype/transactiontype-picklist.component';
import CoaPicklist from '../coa/coa-picklist.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class JournalgroupdetailEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadTransactiontype = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'transactiontype': data?.id, 'transactiontypeCaption': data?.name || ''  }  });
    }
    
    private onLoadCoa = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'coa': data?.id, 'coaCaption': data?.name || ''  }  });
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} 
                model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError}>              
                
                <InputPicklist name='transactiontype' label='Transaction Type' value={this.state.datarow.transactiontype} caption={this.state.datarow.transactiontypeCaption} error={this.state.errors?.transactiontype} onChange={this.onChange} >
                    <TransactiontypePicklist currentId={this.state.datarow.transactiontype} onLoad={this.onLoadTransactiontype}/>
                </InputPicklist>   
                <InputSelect name='sign' label='Debet/Credit' value={this.state.datarow.sign} options={Model.optionSign} error={this.state.errors?.sign} onChange={this.onChange} />
                <InputPicklist name='coa' label='COA' value={this.state.datarow.coa} caption={this.state.datarow.coaCaption} error={this.state.errors?.coa} onChange={this.onChange} >
                    <CoaPicklist currentId={this.state.datarow.coa} onLoad={this.onLoadCoa}/>
                </InputPicklist> 
            </BaseEdit>
        );
    }
}